<i *ngIf="!showAvatar || !avatarUrl" class="icon-car" [ngStyle]="iconStyle"></i>
<img *ngIf="showAvatar && avatarUrl" src="{{avatarUrl}}" class="new-icon" [style.border-color]="color" />
<div *ngIf="ignition" class="ignition" [style.border-color]="color"></div>
